import React from 'react';
import ReactPaginate from 'react-paginate';
import defaultStyles from './Paginate.module.postcss';

function Paginate({ theme, ...props }) {
  const styles = theme || defaultStyles;

  return (
    <ReactPaginate
      containerClassName={styles.Pagination}
      pageClassName={styles.Pagination_page}
      activeClassName={styles.Pagination_selected}
      nextClassName={styles.Pagination_next}
      previousClassName={styles.Pagination_previous}
      breakClassName={styles.Pagination_break}
      disabledClassName={styles.Pagination_disabled}
      {...props}
    />
  );
}

export default Paginate;
